// AUTO-GENERATED FILE. DO NOT EDIT.
// Source: src/styles.css
const STYLE_ID = "copilot-agents-react-styles";
const STYLES = `
/* ─── Scoped Base ─────────────────────────────────────────────────── */
.copilot-agents-root,
.copilot-agents-root *,
.copilot-agents-root *::before,
.copilot-agents-root *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.copilot-agents-root {
    --bg: #0d1117;
    --bg-surface: #161b22;
    --bg-surface-hover: #1c2333;
    --border: #30363d;
    --text: #e6edf3;
    --text-muted: #8b949e;
    --accent: #58a6ff;
    --accent-dim: #1f6feb;
    --user-bg: #1f3a5f;
    --assistant-bg: #161b22;
    --system-bg: #2d1b1b;
    --danger: #f85149;
    --success: #3fb950;
    --warning: #d29922;
    --radius: 8px;
    --font-mono: "Cascadia Code", "Fira Code", "JetBrains Mono", monospace;

    color: var(--text);
    background: var(--bg);
    font-family:
        -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
        sans-serif;
    font-size: 14px;
    line-height: 1.5;
    height: 100%;
}

/* ─── ChatView ────────────────────────────────────────────────────── */

.copilot-agents-root .chat-view {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

.copilot-agents-root .new-chat-prompt-backdrop {
    position: absolute;
    inset: 0;
    z-index: 20;
    display: grid;
    place-items: center;
    padding: 20px;
    background: rgba(1, 4, 9, 0.72);
}

.copilot-agents-root .new-chat-prompt {
    width: min(100%, 380px);
    padding: 20px;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: var(--bg-surface);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.copilot-agents-root .new-chat-prompt h2 {
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 1.3;
}

.copilot-agents-root .new-chat-prompt p {
    color: var(--text-muted);
}

.copilot-agents-root .new-chat-prompt blockquote {
    margin-top: 14px;
    padding: 10px 12px;
    border-left: 3px solid var(--accent);
    background: var(--bg);
    color: var(--text);
}

.copilot-agents-root .new-chat-prompt-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 18px;
}

.copilot-agents-root .new-chat-prompt-actions button {
    min-height: 34px;
    padding: 6px 12px;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    color: var(--text);
    font: inherit;
    cursor: pointer;
}

.copilot-agents-root .new-chat-prompt-cancel {
    background: transparent;
}

.copilot-agents-root .new-chat-prompt-confirm {
    border-color: var(--accent-dim);
    background: var(--accent-dim);
}

.copilot-agents-root .new-chat-prompt-actions button:hover {
    filter: brightness(1.12);
}

/* ─── Toolbar ─────────────────────────────────────────────────────── */

.copilot-agents-root .toolbar {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 12px 16px;
    background: var(--bg-surface);
    border-bottom: 1px solid var(--border);
}

.copilot-agents-root .agent-selector,
.copilot-agents-root .model-selector,
.copilot-agents-root .option-selector {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    width: 100%;
    min-width: 0;
}

.copilot-agents-root .model-selector label,
.copilot-agents-root .agent-selector label,
.copilot-agents-root .option-selector label {
    font-weight: 600;
    color: var(--text-muted);
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.copilot-agents-root .agent-selector-trigger,
.copilot-agents-root .model-selector-trigger,
.copilot-agents-root .option-selector-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex: 1;
    min-width: 0;
    background: var(--bg);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
    font-family: inherit;
}

.copilot-agents-root .agent-selector-trigger:hover:not(:disabled),
.copilot-agents-root .model-selector-trigger:hover:not(:disabled),
.copilot-agents-root .option-selector-trigger:hover:not(:disabled) {
    border-color: var(--accent);
}

.copilot-agents-root .agent-selector-trigger:disabled,
.copilot-agents-root .model-selector-trigger:disabled,
.copilot-agents-root .option-selector-trigger:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.copilot-agents-root .agent-selector-chevron,
.copilot-agents-root .model-selector-chevron,
.copilot-agents-root .option-selector-chevron {
    font-size: 10px;
    color: var(--text-muted);
}

.copilot-agents-root .message-status {
    margin-left: 6px;
    font-size: 12px;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.copilot-agents-root .agent-selector-dropdown,
.copilot-agents-root .model-selector-dropdown,
.copilot-agents-root .option-selector-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    background: var(--bg-surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    min-width: 280px;
    max-width: 420px;
    max-height: min(420px, 60vh);
    z-index: 100;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
    overflow-y: auto;
}

.copilot-agents-root .model-selector-dropdown {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.copilot-agents-root .model-selector-filter {
    flex: none;
    padding: 8px;
    background: var(--bg-surface);
    border-bottom: 1px solid var(--border);
}

.copilot-agents-root .model-selector-filter input {
    width: 100%;
    min-width: 0;
    padding: 6px 8px;
    background: var(--bg);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: 4px;
    font-family: inherit;
    font-size: 13px;
    outline: none;
}

.copilot-agents-root .model-selector-filter input:focus {
    border-color: var(--accent);
}

.copilot-agents-root .model-selector-filter input::placeholder {
    color: var(--text-muted);
}

.copilot-agents-root .model-selector-options {
    min-height: 0;
    overflow-y: auto;
}

.copilot-agents-root .model-selector-empty {
    padding: 16px 12px;
    color: var(--text-muted);
    font-size: 12px;
    text-align: center;
}

.copilot-agents-root .agent-selector-option,
.copilot-agents-root .model-selector-option,
.copilot-agents-root .option-selector-option {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    padding: 8px 12px;
    background: none;
    border: none;
    border-bottom: 1px solid var(--border);
    cursor: pointer;
    text-align: left;
    font-family: inherit;
    color: var(--text);
}

.copilot-agents-root .agent-selector-option:last-child,
.copilot-agents-root .model-selector-option:last-child,
.copilot-agents-root .option-selector-option:last-child {
    border-bottom: none;
}

.copilot-agents-root .agent-selector-option:hover,
.copilot-agents-root .model-selector-option:hover,
.copilot-agents-root .option-selector-option:hover {
    background: var(--bg-surface-hover);
}

.copilot-agents-root .agent-selector-option--active,
.copilot-agents-root .model-selector-option--active,
.copilot-agents-root .option-selector-option--active {
    background: rgba(88, 166, 255, 0.1);
    border-left: 2px solid var(--accent);
}

.copilot-agents-root .agent-option-name,
.copilot-agents-root .model-option-name,
.copilot-agents-root .option-selector-option-name {
    font-size: 13px;
    font-weight: 600;
}

.copilot-agents-root .agent-option-desc,
.copilot-agents-root .model-option-id,
.copilot-agents-root .option-selector-option-description {
    font-size: 11px;
    color: var(--text-muted);
    line-height: 1.4;
}

.copilot-agents-root .model-option-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    width: 100%;
}

.copilot-agents-root .model-option-badges {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
}

.copilot-agents-root .model-option-sub {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.copilot-agents-root .model-badge--discount {
    background: rgba(63, 185, 80, 0.12);
    color: #3fb950;
    border: 1px solid rgba(63, 185, 80, 0.25);
}

.copilot-agents-root .model-selector-option--auto .model-option-badges {
    justify-content: center;
}

.copilot-agents-root .model-badge-sub {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.copilot-agents-root .model-badge-link {
    font-size: 10px;
    font-weight: 500;
    color: #79c0ff;
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
    line-height: 1.4;
    text-align: center;
}

.copilot-agents-root .model-badge-link:hover {
    color: #a5d6ff;
}

.copilot-agents-root .model-selector-trigger-content {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    overflow: hidden;
}

.copilot-agents-root .model-selector-trigger-badges {
    flex-shrink: 0;
    margin-left: 2px;
}

.copilot-agents-root .model-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 5px;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.3;
    border-radius: 4px;
    letter-spacing: 0.2px;
    white-space: nowrap;
}

.copilot-agents-root .model-badge--category {
    background: rgba(88, 166, 255, 0.12);
    color: #58a6ff;
    border: 1px solid rgba(88, 166, 255, 0.25);
}

.copilot-agents-root .model-badge--lightweight {
    background: rgba(57, 197, 207, 0.12);
    color: #39c5cf;
    border: 1px solid rgba(57, 197, 207, 0.25);
}

.copilot-agents-root .model-badge--versatile {
    background: rgba(88, 166, 255, 0.12);
    color: #58a6ff;
    border: 1px solid rgba(88, 166, 255, 0.25);
}

.copilot-agents-root .model-badge--powerful {
    background: rgba(188, 140, 255, 0.12);
    color: #bc8cff;
    border: 1px solid rgba(188, 140, 255, 0.25);
}

.copilot-agents-root .model-badge--discount {
    background: rgba(63, 185, 80, 0.12);
    color: #3fb950;
    border: 1px solid rgba(63, 185, 80, 0.25);
}

.copilot-agents-root .model-badge--price {
    font-size: 10px;
    font-family: var(--font-mono);
    font-weight: 700;
}

.copilot-agents-root .model-badge--low {
    background: rgba(63, 185, 80, 0.12);
    color: #3fb950;
    border: 1px solid rgba(63, 185, 80, 0.25);
}

.copilot-agents-root .model-badge--medium {
    background: rgba(210, 153, 34, 0.12);
    color: #d29922;
    border: 1px solid rgba(210, 153, 34, 0.25);
}

.copilot-agents-root .model-badge--high {
    background: rgba(240, 136, 62, 0.12);
    color: #f0883e;
    border: 1px solid rgba(240, 136, 62, 0.25);
}

.copilot-agents-root .model-badge--very_high {
    background: rgba(248, 81, 73, 0.12);
    color: #f85149;
    border: 1px solid rgba(248, 81, 73, 0.25);
}

.copilot-agents-root .toolbar-action-row {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    width: 100%;
    min-width: 0;
}

.copilot-agents-root .toolbar-action-row .option-selector {
    flex: 1 1 0;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    width: auto;
}

.copilot-agents-root .toolbar-action-row .option-selector label {
    align-self: flex-start;
}

.copilot-agents-root .toolbar-action-row .option-selector-trigger {
    width: 100%;
    padding-inline: 8px;
}

.copilot-agents-root .toolbar-action-row .option-selector-dropdown {
    width: max-content;
    min-width: 180px;
    max-width: 240px;
}

.copilot-agents-root .toolbar-action-row .btn-new {
    flex: none;
}

.copilot-agents-root .mode-toggle {
    background: var(--bg);
    color: var(--accent);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 6px 14px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s;
}

.copilot-agents-root .mode-toggle:hover {
    background: var(--bg-surface-hover);
    border-color: var(--accent);
}

.copilot-agents-root .btn-new {
    background: var(--bg);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 6px 14px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s;
}

.copilot-agents-root .btn-new:hover {
    background: var(--bg-surface-hover);
}

.copilot-agents-root .btn-new:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.copilot-agents-root .toolbar-spacer {
    display: none;
}

.copilot-agents-root .btn-new {
    align-self: flex-end;
}

.copilot-agents-root .toolbar-description {
    width: 100%;
    font-size: 12px;
    color: var(--text-muted);
    line-height: 1.4;
    cursor: default;
    word-break: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.copilot-agents-root .toolbar-description:hover {
    white-space: normal;
    overflow: visible;
}

/* ─── Loading / Error ─────────────────────────────────────────────── */

.copilot-agents-root .loading,
.copilot-agents-root .error-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
    padding: 32px;
}

.copilot-agents-root .error-panel h2 {
    color: var(--danger);
    margin-bottom: 8px;
}

.copilot-agents-root .error-panel p {
    color: var(--text-muted);
}

.copilot-agents-root .btn-retry {
    margin-top: 16px;
    padding: 8px 20px;
    font-size: 0.9rem;
    background: var(--accent-dim);
    color: var(--text);
    border: none;
    border-radius: 6px;
    cursor: pointer;
}

.copilot-agents-root .btn-retry:hover {
    background: var(--accent);
}

/* ─── Message List ────────────────────────────────────────────────── */

.copilot-agents-root .message-list {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.copilot-agents-root .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--text-muted);
    font-size: 15px;
}

/* ─── Messages ────────────────────────────────────────────────────── */

.copilot-agents-root .message {
    padding: 12px 16px;
    border-radius: var(--radius);
    max-width: 85%;
}

.copilot-agents-root .message--user {
    background: var(--user-bg);
    align-self: flex-end;
    border-bottom-right-radius: 2px;
}

.copilot-agents-root .message--assistant {
    background: var(--assistant-bg);
    border: 1px solid var(--border);
    align-self: flex-start;
    border-bottom-left-radius: 2px;
}

.copilot-agents-root .message--system {
    background: var(--system-bg);
    border: 1px solid var(--danger);
    align-self: center;
    font-size: 13px;
}

.copilot-agents-root .message-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
    user-select: none;
}

.copilot-agents-root .message-role {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-muted);
}

.copilot-agents-root .message-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.copilot-agents-root .message-action {
    display: inline-grid;
    place-items: center;
    width: 22px;
    height: 22px;
    font-size: 16px;
    font-weight: 700;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--text-muted);
    cursor: pointer;
    transition: color 0.15s ease;
    line-height: 1;
    opacity: 0;
}

.copilot-agents-root .message:hover .message-action,
.copilot-agents-root .message-action:focus-visible {
    opacity: 1;
}

.copilot-agents-root .message-action:hover {
    color: var(--text);
}

.copilot-agents-root .message-action:active {
    color: var(--accent);
}

.copilot-agents-root .message-content {
    word-break: break-word;
}

.copilot-agents-root .message-content p {
    margin: 4px 0;
}

.copilot-agents-root .message-content> :last-child {
    margin-bottom: 0;
}

.copilot-agents-root .message-content pre {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 4px;
    padding: 8px 12px;
    overflow-x: auto;
    font-family: var(--font-mono);
    font-size: 13px;
    margin: 8px 0;
}

.copilot-agents-root .message-content code {
    background: var(--bg);
    padding: 2px 5px;
    border-radius: 3px;
    font-family: var(--font-mono);
    font-size: 13px;
}

.copilot-agents-root .message-content pre code {
    background: none;
    padding: 0;
}

.copilot-agents-root .message-content a {
    color: var(--accent);
    text-decoration: underline;
    text-underline-offset: 2px;
    word-break: break-all;
}

.copilot-agents-root .message-content a:hover {
    color: #79c0ff;
    text-decoration-color: #79c0ff;
}

.copilot-agents-root .message-content ul,
.copilot-agents-root .message-content ol {
    padding-left: 1.5em;
    margin: 4px 0;
}

.copilot-agents-root .message-content li {
    margin: 2px 0;
}

.copilot-agents-root .message-content li>p {
    margin: 0;
}

.copilot-agents-root .message-content table {
    border-collapse: collapse;
    width: 100%;
    margin: 8px 0;
    font-size: 13px;
}

.copilot-agents-root .message-content th,
.copilot-agents-root .message-content td {
    border: 1px solid var(--border);
    padding: 6px 10px;
    text-align: left;
}

.copilot-agents-root .message-content th {
    background: var(--bg);
    font-weight: 600;
}

.copilot-agents-root .message-content tr:hover {
    background: rgba(255, 255, 255, 0.03);
}

.copilot-agents-root .message-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
    user-select: none;
}

.copilot-agents-root .message-time {
    font-size: 10px;
    color: var(--text-muted);
    margin-left: auto;
}

.copilot-agents-root .message--user .message-time {
    color: #a2adb8;
}

.copilot-agents-root .cursor-blink {
    animation: copilot-agents-blink 1s step-end infinite;
    color: var(--accent);
}

@keyframes copilot-agents-blink {
    50% {
        opacity: 0;
    }
}

/* ─── Thinking / Reasoning Block ──────────────────────────────────── */

.copilot-agents-root .thinking-block {
    margin: 8px 0;
    border: 1px solid var(--border);
    border-radius: 4px;
    background: color-mix(in srgb, var(--warning) 6%, var(--bg));
    font-size: 13px;
    overflow: hidden;
}

.copilot-agents-root .thinking-summary {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-muted);
    user-select: none;
    list-style: none;
}

.copilot-agents-root .thinking-summary::before {
    content: ">";
    font-size: 9px;
    transition: transform 0.15s ease;
}

.copilot-agents-root .thinking-block[open]>.thinking-summary::before {
    transform: rotate(90deg);
}

.copilot-agents-root .thinking-summary::-webkit-details-marker {
    display: none;
}

.copilot-agents-root .thinking-content {
    padding: 4px 12px 10px;
    border-top: 1px solid var(--border);
    color: var(--text-muted);
    font-style: italic;
    max-height: 300px;
    overflow-y: auto;
    word-break: break-word;
    scrollbar-color: var(--border) transparent;
    scrollbar-width: thin;
}

.copilot-agents-root .thinking-content::-webkit-scrollbar {
    width: 6px;
}

.copilot-agents-root .thinking-content::-webkit-scrollbar-track {
    background: transparent;
}

.copilot-agents-root .thinking-content::-webkit-scrollbar-thumb {
    background: var(--border);
    border-radius: 3px;
}

.copilot-agents-root .thinking-content::-webkit-scrollbar-thumb:hover {
    background: var(--text-muted);
}

.copilot-agents-root .thinking-content p {
    margin: 4px 0;
}

.copilot-agents-root .thinking-content pre {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 4px;
    padding: 6px 10px;
    overflow-x: auto;
    font-family: var(--font-mono);
    font-size: 12px;
    font-style: normal;
    margin: 6px 0;
}

.copilot-agents-root .thinking-content code {
    font-family: var(--font-mono);
    font-size: 12px;
    font-style: normal;
}

/* ─── Tool Calls ──────────────────────────────────────────────────── */

.copilot-agents-root .tool-calls-wrapper {
    margin: 8px 0;
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 4px;
    font-size: 12px;
}

.copilot-agents-root .tool-calls-summary {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    cursor: pointer;
    user-select: none;
    list-style: none;
    font-size: 12px;
    color: var(--text-muted);
    font-weight: 500;
}

.copilot-agents-root .tool-calls-summary::-webkit-details-marker {
    display: none;
}

.copilot-agents-root .tool-calls-summary::before {
    content: ">";
    font-size: 9px;
    color: var(--text-muted);
    flex-shrink: 0;
    transition: transform 0.15s;
}

.copilot-agents-root .tool-calls-wrapper[open]>.tool-calls-summary::before {
    transform: rotate(90deg);
}

.copilot-agents-root .tool-calls {
    border-top: 1px solid var(--border);
    font-size: 12px;
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.copilot-agents-root .tool-call {
    border-bottom: 1px solid var(--border);
}

.copilot-agents-root .tool-call:last-child {
    border-bottom: none;
}

.copilot-agents-root .tool-call-summary {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px 5px 20px;
    cursor: pointer;
    user-select: none;
    list-style: none;
}

.copilot-agents-root .tool-call-summary::-webkit-details-marker {
    display: none;
}

.copilot-agents-root .tool-call-summary::before {
    content: ">";
    font-size: 9px;
    color: var(--text-muted);
    flex-shrink: 0;
    transition: transform 0.15s;
}

.copilot-agents-root .tool-call[open]>.tool-call-summary::before {
    transform: rotate(90deg);
}

.copilot-agents-root .tool-call-args-preview {
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 11px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
}

.copilot-agents-root .tool-call-summary:hover {
    background: var(--bg-surface-hover);
}

.copilot-agents-root .tool-call-detail {
    padding: 4px 8px 8px 22px;
    border-top: 1px solid var(--border);
}

.copilot-agents-root .tool-call {
    display: block;
}

.copilot-agents-root .tool-call-icon {
    flex-shrink: 0;
}

.copilot-agents-root .tool-call-name {
    font-weight: 600;
    color: var(--warning);
}

.copilot-agents-root .tool-call-args {
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 11px;
}

.copilot-agents-root .tool-call-result {
    width: 100%;
    background: var(--bg-surface);
    border: 1px solid var(--border);
    border-radius: 4px;
    padding: 6px 8px;
    font-family: var(--font-mono);
    font-size: 11px;
    color: var(--text-muted);
    overflow-x: auto;
    margin-top: 4px;
    white-space: pre-wrap;
    word-break: break-word;
}

/* ─── Confirmation Dialog ─────────────────────────────────────────── */

.copilot-agents-root .confirmation-dialog {
    margin-top: 12px;
    border: 1px solid var(--warning);
    border-radius: var(--radius);
    padding: 12px;
    background: rgba(210, 153, 34, 0.08);
}

.copilot-agents-root .confirmation-header {
    font-weight: 600;
    color: var(--warning);
    margin-bottom: 8px;
}

.copilot-agents-root .confirmation-tools {
    list-style: none;
    margin-bottom: 12px;
}

.copilot-agents-root .confirmation-tools li {
    padding: 8px 0;
    border-bottom: 1px solid var(--border);
}

.copilot-agents-root .confirmation-tools li:last-child {
    border-bottom: none;
}

.copilot-agents-root .confirmation-tools strong {
    color: var(--text);
}

.copilot-agents-root .tool-desc {
    display: block;
    color: var(--text-muted);
    font-size: 12px;
    margin: 2px 0;
}

.copilot-agents-root .tool-args {
    font-family: var(--font-mono);
    font-size: 11px;
    color: var(--text-muted);
    background: var(--bg);
    padding: 4px 8px;
    border-radius: 4px;
    margin-top: 4px;
}

.copilot-agents-root .confirmation-actions {
    display: flex;
    gap: 8px;
}

.copilot-agents-root .btn-approve,
.copilot-agents-root .btn-deny {
    padding: 6px 16px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.15s;
}

.copilot-agents-root .btn-approve {
    background: rgba(63, 185, 80, 0.15);
    color: var(--success);
    border-color: var(--success);
}

.copilot-agents-root .btn-approve:hover {
    background: rgba(63, 185, 80, 0.3);
}

.copilot-agents-root .btn-deny {
    background: rgba(248, 81, 73, 0.15);
    color: var(--danger);
    border-color: var(--danger);
}

.copilot-agents-root .btn-deny:hover {
    background: rgba(248, 81, 73, 0.3);
}

/* ─── Interactive Questions Form (ask_questions) ─────────────────── */

.copilot-agents-root .questions-form {
    margin-top: 12px;
    border: 1px solid var(--accent-dim);
    border-radius: var(--radius);
    padding: 12px 14px;
    background: rgba(31, 111, 235, 0.06);
}

.copilot-agents-root .questions-header {
    font-weight: 600;
    color: var(--accent);
    margin-bottom: 10px;
}

.copilot-agents-root .question-item {
    padding: 8px 0;
    border-bottom: 1px solid var(--border);
}

.copilot-agents-root .question-item:last-of-type {
    border-bottom: none;
}

.copilot-agents-root .question-text {
    font-weight: 500;
    color: var(--text);
    margin-bottom: 2px;
}

.copilot-agents-root .question-message {
    color: var(--text-muted);
    font-size: 12px;
    margin-bottom: 6px;
}

.copilot-agents-root .question-options {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 6px 0;
}

.copilot-agents-root .question-option {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 6px 8px;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    cursor: pointer;
    transition: all 0.15s;
}

.copilot-agents-root .question-option:hover {
    border-color: var(--accent-dim);
    background: rgba(31, 111, 235, 0.08);
}

.copilot-agents-root .question-option.is-selected {
    border-color: var(--accent);
    background: rgba(31, 111, 235, 0.14);
}

.copilot-agents-root .question-option input {
    margin-top: 2px;
}

.copilot-agents-root .question-option-label {
    display: flex;
    flex-direction: column;
    font-size: 13px;
    color: var(--text);
}

.copilot-agents-root .question-option-badge {
    display: inline-block;
    margin-left: 0;
    margin-top: 2px;
    align-self: flex-start;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--success);
    border: 1px solid var(--success);
    border-radius: 4px;
    padding: 0 4px;
}

.copilot-agents-root .question-option-desc {
    color: var(--text-muted);
    font-size: 12px;
    margin-top: 2px;
}

.copilot-agents-root .question-freetext {
    width: 100%;
    margin-top: 6px;
    padding: 6px 8px;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: var(--bg);
    color: var(--text);
    font-size: 13px;
    font-family: inherit;
}

.copilot-agents-root .question-freetext:focus {
    outline: none;
    border-color: var(--accent);
}

.copilot-agents-root .questions-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.copilot-agents-root .btn-submit-answers {
    padding: 6px 16px;
    border-radius: var(--radius);
    border: 1px solid var(--accent);
    background: rgba(31, 111, 235, 0.15);
    color: var(--accent);
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.15s;
}

.copilot-agents-root .btn-submit-answers:hover:not(:disabled) {
    background: rgba(31, 111, 235, 0.3);
}

.copilot-agents-root .btn-submit-answers:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ─── Combined pending resolution (confirmation + questions) ─────── */

.copilot-agents-root .pending-resolution-confirm {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid var(--border);
}

/* ─── Auth Required ───────────────────────────────────────────────── */

.copilot-agents-root .auth-required {
    margin-top: 12px;
    border: 1px solid var(--accent-dim);
    border-radius: var(--radius);
    padding: 12px;
    background: rgba(31, 111, 235, 0.08);
}

.copilot-agents-root .auth-link {
    color: var(--accent);
    font-weight: 500;
    text-decoration: none;
}

.copilot-agents-root .auth-link:hover {
    text-decoration: underline;
}

/* ─── Starter Questions (inline, above input) ────────────────────── */

.copilot-agents-root .chat-starters {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px 16px;
}

.copilot-agents-root .chat-starter {
    background: var(--bg-surface);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 8px 14px;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
    text-align: left;
    line-height: 1.4;
    transition: border-color 0.08s, background 0.08s;
}

.copilot-agents-root .chat-starter:hover {
    border-color: var(--accent);
    background: var(--bg-surface-hover);
}

/* ─── Message Input ───────────────────────────────────────────────── */

.copilot-agents-root .message-input {
    padding: 8px 16px;
    background: var(--bg-surface);
    border-top: 1px solid var(--border);
}

.copilot-agents-root .message-input-wrapper {
    position: relative;
    display: flex;
    align-items: flex-end;
}

.copilot-agents-root .message-input textarea {
    flex: 1;
    background: var(--bg);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 10px 38px 10px 14px;
    font-size: 14px;
    font-family: inherit;
    resize: none;
    line-height: 1.4;
    max-height: 160px;
    overflow-y: auto;
    scrollbar-color: var(--border) transparent;
    scrollbar-width: thin;
}

.copilot-agents-root .message-input textarea::-webkit-scrollbar {
    width: 6px;
}

.copilot-agents-root .message-input textarea::-webkit-scrollbar-track {
    background: transparent;
}

.copilot-agents-root .message-input textarea::-webkit-scrollbar-thumb {
    background: var(--border);
    border-radius: 3px;
}

.copilot-agents-root .message-input textarea::-webkit-scrollbar-thumb:hover {
    background: var(--text-muted);
}

.copilot-agents-root .message-input textarea:focus {
    outline: none;
    border-color: var(--accent);
}

.copilot-agents-root .message-input textarea::placeholder {
    color: var(--text-muted);
}

.copilot-agents-root .message-input button {
    position: absolute;
    right: 6px;
    bottom: 6px;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: var(--accent-dim);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    transition: background 0.15s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.copilot-agents-root .message-input button:hover:not(:disabled) {
    background: var(--accent);
}

.copilot-agents-root .message-input button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.copilot-agents-root .ai-disclaimer {
    text-align: center;
    font-size: 11px;
    color: var(--text-muted);
    padding: 2px 16px 6px;
}

/* ─── Scrollbar ───────────────────────────────────────────────────── */

.copilot-agents-root .message-list::-webkit-scrollbar {
    width: 6px;
}

.copilot-agents-root .message-list::-webkit-scrollbar-track {
    background: transparent;
}

.copilot-agents-root .message-list::-webkit-scrollbar-thumb {
    background: var(--border);
    border-radius: 3px;
}

.copilot-agents-root .message-list::-webkit-scrollbar-thumb:hover {
    background: var(--text-muted);
}

.copilot-agents-root .btn-scroll-bottom {
    position: sticky;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid var(--border);
    background: var(--bg-surface);
    color: var(--text-muted);
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease, color 0.15s ease;
    z-index: 1;
}

.copilot-agents-root .btn-scroll-bottom:hover {
    background: var(--bg-surface-hover);
    color: var(--text);
}

/* ─── Chat Bubble + Panel ─────────────────────────────────────────── */

.copilot-agents-root.copilot-agents-bubble-root {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 9999;
    background: transparent;
    height: auto;
}

.copilot-agents-root .copilot-agents-bubble-shell {
    position: fixed;
    right: 24px;
    bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    pointer-events: auto;
}

.copilot-agents-root .copilot-agents-bubble-button-wrapper {
    position: relative;
    display: inline-block;
}

.copilot-agents-root .copilot-agents-bubble-dismiss {
    position: absolute;
    top: -9px;
    right: -2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #000;
    color: #fff;
    border: none;
    font-size: 10px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 1;
    opacity: 0;
    pointer-events: none;
    transition: background 0.15s ease, opacity 0.15s ease;
}

.copilot-agents-root .copilot-agents-bubble-button-wrapper:hover .copilot-agents-bubble-dismiss {
    opacity: 1;
    pointer-events: auto;
}

.copilot-agents-root .copilot-agents-bubble-dismiss:hover {
    background: #333;
}

.copilot-agents-root .copilot-agents-bubble-button {
    width: 52px;
    height: 52px;
    border-radius: 26px;
    background: var(--bg);
    color: #fff;
    border: 1px solid var(--border);
    font-size: 22px;
    cursor: pointer;
    pointer-events: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
    transition: transform 0.25s ease, background 0.25s ease;
}

.copilot-agents-root .copilot-agents-bubble-button:hover {
    background: var(--bg-surface-hover);
    transform: scale(1.08);
}

.copilot-agents-root .copilot-agents-suggestions {
    width: min(320px, 80vw);
    background: var(--bg-surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.35);
    animation: copilot-suggestions-in 0.25s ease-out;
}

@keyframes copilot-suggestions-in {
    from {
        opacity: 0;
        transform: translateY(8px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.copilot-agents-root .copilot-agents-suggestions-title {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-muted);
    margin-bottom: 8px;
}

.copilot-agents-root .copilot-agents-suggestions-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.copilot-agents-root .copilot-agents-suggestion {
    text-align: left;
    background: var(--bg);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.08s ease, border-color 0.08s ease;
}

.copilot-agents-root .copilot-agents-suggestion:hover {
    background: var(--bg-surface-hover);
    border-color: var(--accent);
}

.copilot-agents-root .copilot-agents-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(2px);
    pointer-events: auto;
    opacity: 1;
    transition: opacity 0.15s ease;
}

.copilot-agents-root .copilot-agents-backdrop--hidden {
    opacity: 0;
    pointer-events: none;
}

.copilot-agents-root .copilot-agents-panel {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    max-width: 92vw;
    background: var(--bg);
    border-left: 1px solid var(--border);
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.4);
    transform: translateX(0);
    opacity: 1;
    transition: transform 0.18s ease, opacity 0.18s ease;
}

.copilot-agents-root .copilot-agents-panel--hidden {
    transform: translateX(100%);
    opacity: 0;
    pointer-events: none;
}

.copilot-agents-root .copilot-agents-panel--fullscreen {
    left: 0;
    right: 0;
    width: 100vw;
    max-width: 100vw;
    border-left: none;
}

.copilot-agents-root .copilot-agents-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: var(--bg-surface);
    border-bottom: 1px solid var(--border);
    font-weight: 600;
}

.copilot-agents-root .copilot-agents-panel-title {
    font-size: 14px;
}

.copilot-agents-root .copilot-agents-panel-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.copilot-agents-root .copilot-agents-panel-action {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid var(--border);
    background: var(--bg);
    color: var(--text);
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
}

.copilot-agents-root .copilot-agents-panel-action:hover {
    background: var(--bg-surface-hover);
}

.copilot-agents-root .copilot-agents-panel-close {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid var(--border);
    background: var(--bg);
    color: var(--text);
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
}

.copilot-agents-root .copilot-agents-panel-close:hover {
    background: var(--bg-surface-hover);
}

.copilot-agents-root .copilot-agents-panel-body {
    flex: 1;
    min-height: 0;
}
`;
export function ensureStyles() {
    if (typeof document === "undefined")
        return;
    if (document.getElementById(STYLE_ID))
        return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = STYLES;
    document.head.appendChild(style);
}
//# sourceMappingURL=styles.js.map